import { render, staticRenderFns } from "./user-edit-modal.component.vue?vue&type=template&id=f9f84a9a&scoped=true"
import script from "./user-edit-modal.component.vue?vue&type=script&lang=ts"
export * from "./user-edit-modal.component.vue?vue&type=script&lang=ts"
import style0 from "./user-edit-modal.component.vue?vue&type=style&index=0&id=f9f84a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f84a9a",
  null
  
)

export default component.exports